import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import {Spinner} from '../../../components'

import UpcomingTaskStore from './UpcomingTasksStore';
import UpcomingTask from './UpcomingTask';

const UpcomingTasks = observer(class UpcomingTasks extends Component {
  constructor(props){
    super(props);

  }
  componentWillMount(){
    this.taskStore = new UpcomingTaskStore();
    this.taskStore.loadUpcomingTasks();
  }

  onTaskClick(task){
    window.location.href = `/#/workflow2/view-task/${task.prefixedFriendlyId}`;
  }

  render(){
    if(this.taskStore.isLoading){
      return (<div className="col-md-12"><Spinner center timeout={0}/></div>);
    }
    let tasks;
    if(this.taskStore.tasks.length){
      tasks = this.taskStore.tasks.map(task => <UpcomingTask key={`task-${task._id}`} task={task} onClick={() => this.onTaskClick(task)} />);
    }else{
      tasks = (<Fragment><h4 className="text-center">You're up to date! All tasks complete.</h4></Fragment>);
    }

    return (<ul className="list-group">
            {tasks}
            <a className="btn btn-secondary btn-block content-spacer-top" href="#/workflow2/">
              View All Tasks
            </a>
          </ul>);
  }
});

export default UpcomingTasks;
